import {EventType} from './webhook-subscription.model';
import {EventStatus} from './webhook-event.model';

export interface WebhookEventSearchCriteria {
  subscriberId?: string;
  triggeredStartDate?: number;
  triggeredEndDate?: number;
  eventTypes?: Array<EventType>;
  eventStatuses?: Array<EventStatus>;
  externalReference?: string;
  timeZone: string;
}

export enum WebhookEventSortableColumn {
  ID = 'ID',
  TRIGGERED_DATE = 'TRIGGERED_DATE',
  EVENT_TYPE = 'EVENT_TYPE',
  EVENT_STATUS = 'EVENT_STATUS'
}
